import { Culture } from '../../types';

export const quechan: Culture = {
  name: 'Quechan',
  languageFamily: 'Yuman',
  terms: [
    {
      word: 'Ahamak',
      phonetic: 'ah-hah-mahk',
      description: 'Quechan word for "river."'
    },
    {
      word: 'Kwatsan',
      phonetic: 'kwah-tsan',
      description: 'Quechan name for themselves, meaning "The People."'
    },
    {
      word: 'Nyeche',
      phonetic: 'nyeh-cheh',
      description: 'Word for "sun" in Quechan.'
    },
    {
      word: 'Piipa',
      phonetic: 'pee-pah',
      description: 'Word meaning "water" in Quechan.'
    },
    {
      word: 'Tamakwah',
      phonetic: 'tah-mah-kwah',
      description: 'Word for "village" or "community."'
    }
  ]
};